import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/index';
import { formatEventDate } from '../../../../helpers/formatData';
import { getNowInTimeZone } from '../../../../helpers/timezones';
import { dayDateFormat } from '../../../../constants/date';
import { daysDiffForMultipleJobs } from '../../../../constants/jobs';
import Validator from '../../../common/forms/Validator';
import ErrorMessage from '../../../common/forms/ErrorMessage';
import ActionsGroup from '../../../common/ui/ItemActions';

export default class EventForm extends Validator {
  static propTypes = {
    event: PropTypes.shape({
      name: PropTypes.string.isRequired,
      start_date: PropTypes.object.isRequired,
      end_date: PropTypes.object.isRequired
    }),
    showEditIcons: PropTypes.bool.isRequired,
    isEditing: PropTypes.bool.isRequired,
    jobStartDate: PropTypes.object.isRequired,
    jobTimeZoneId: PropTypes.string.isRequired,
    startEditingEvent: PropTypes.func.isRequired,
    stopEditingEvent: PropTypes.func.isRequired,
    submitEditingEvent: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    const { name, start_date, end_date } = props.event;
    this.state = {
      name,
      start_date,
      end_date
    };
  }

  validationRules = {
    name: { required: true },
    start_date: { required: true },
    end_date: { required: true }
  };

  handleChangeName = e => this.setState({ name: e.target.value });

  handleChangeStartDate = start_date => this.setState({ start_date });

  handleChangeEndDate = end_date => this.setState({ end_date });

  handleSubmit = e => {
    e.preventDefault();
    const { name, start_date, end_date } = this.state;
    if (!this.validate(this.validationRules)) {
      return;
    }
    this.props.submitEditingEvent({
      name,
      start_date: formatEventDate(start_date),
      end_date: formatEventDate(end_date)
    });
  };

  cancelEditing = () => {
    const { event: { name, start_date, end_date }, stopEditingEvent } = this.props;
    this.setState({
      name,
      start_date,
      end_date
    });
    this._resetErrors();
    stopEditingEvent();
  };

  render () {
    const { isEditing, jobStartDate, jobTimeZoneId, startEditingEvent, showEditIcons } = this.props;
    const { name, start_date, end_date } = this.state;
    const todayInJobTimeZone = getNowInTimeZone(jobTimeZoneId);
    const eventStartedOrPast = todayInJobTimeZone.startOf('day').isSameOrAfter(start_date && start_date.clone().startOf('day'));
    const eventDateIsEditable = isEditing && !eventStartedOrPast;
    const minStartDate = end_date ? end_date.clone().subtract(daysDiffForMultipleJobs, 'days') : jobStartDate.clone().subtract(daysDiffForMultipleJobs, 'days');
    const maxEndDate = start_date ? start_date.clone().add(daysDiffForMultipleJobs, 'days') : jobStartDate.clone().add(daysDiffForMultipleJobs, 'days');
    const errors = this.validationErrors;
    return (
      <form onSubmit={this.handleSubmit} className='mb-2 position-relative'>
        { showEditIcons && (
          <div className='event-editing-icons'>
            <ActionsGroup
              isEditing={isEditing}
              enterEditMode={startEditingEvent}
              exitEditMode={this.cancelEditing}
            />
          </div>
        )}
        <div className='section-row event-name'>
          { isEditing ? (
            <div className='stretch-width-wrapper'>
              <label htmlFor='event-name-input'>Name:</label>
              <input
                id='event-name-input'
                className='input'
                type='text'
                name='name'
                value={name}
                placeholder='Event name'
                onChange={this.handleChangeName}
              />
              <ErrorMessage errorText={errors.name} />
            </div>
          ) : (
            <p>{name}</p>
          )}
        </div>
        <div className='section-row'>
          { eventDateIsEditable ? (
            <div className='stretch-width-wrapper'>
              <label htmlFor='event-start-date-input'>Start Date:</label>
              <DatePicker
                id='event-start-date-input'
                className='input'
                selected={start_date}
                placeholderText='Start date'
                onChange={this.handleChangeStartDate}
                dateFormat={dayDateFormat}
                minDate={minStartDate}
                maxDate={jobStartDate}
                dropdownMode='select'
              />
              <ErrorMessage errorText={errors.start_date} />
            </div>
          ) : (
            <Fragment>
              <span className='icon-wrapper'><FontAwesomeIcon icon={faCalendarAlt} /></span>
              <p>{start_date.format(dayDateFormat)}</p>
            </Fragment>
          )}
        </div>
        <div className='section-row'>
          { eventDateIsEditable ? (
            <div className='stretch-width-wrapper'>
              <label htmlFor='event-end-date-input'>End Date:</label>
              <DatePicker
                id='event-end-date-input'
                className='input'
                selected={end_date}
                placeholderText='End date'
                onChange={this.handleChangeEndDate}
                dateFormat={dayDateFormat}
                minDate={jobStartDate}
                maxDate={maxEndDate}
                dropdownMode='select'
              />
              <ErrorMessage errorText={errors.end_date} />
            </div>
          ) : (
            <Fragment>
              <span className='icon-wrapper'><FontAwesomeIcon icon={faCalendarAlt} /></span>
              <p>{end_date.format(dayDateFormat)}</p>
            </Fragment>
          )}
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/JobDetailsTab/EventForm.js